import { render, staticRenderFns } from "./ScreenTranslucenciaNucalDopplerPerfilCervical.vue?vue&type=template&id=86fda2a4&scoped=true&"
import script from "./ScreenTranslucenciaNucalDopplerPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalDopplerPerfilCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalDopplerPerfilCervical.vue?vue&type=style&index=0&id=86fda2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fda2a4",
  null
  
)

export default component.exports